import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useTheme } from "hooks";
import ViewButton from "./LeftSectionBody/ViewButton/ViewButton";
import ViewButtonContainer from "./LeftSectionBody/ViewButtonContainer/ViewButtonContainer";
import InformationSection from "./LeftSectionBody/InformationSection/InformationSection";
import InformationRow from './LeftSectionBody/InformationRow/InformationRow';
import { SvgComponent } from "components";

export default function LeftSectionBody(props) {
    const { theme } = useTheme();

    return (
        <div className="mt-5" style={{ maxHeight: "calc(100vh - 50px)" }}>
            <div className="text-center mb-3">
                {props.showImage && (
                    <div className={`mb-1 ${props.img64.length > 25 ? `` : `d-flex justify-content-center`} `} style={{ height: `70%` }} >
                        {props.img64.length > 25 ? (
                            <img
                                src={
                                    props.img64 ??
                                    "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"
                                }
                                style={{
                                    borderRadius: "50%",
                                    width: "22%",
                                    margin: "0",
                                }}
                            ></img>
                        ) : (
                            <div
                                style={{
                                    backgroundColor: theme.color1,
                                    borderRadius: `50%`,
                                    margin: "0px",
                                    width: "110px",
                                    height: "110px",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                }}
                            >
                                <SvgComponent
                                    iconName={props.icon}
                                    height="60"
                                    width="60"
                                    fill="white"
                                    style={{ margin: "25px" }}
                                />
                            </div>
                        )}
                    </div>
                )}

                {props.title !== undefined ? (
                    <div
                        style={{
                            position: "relative",
                            paddingTop: "20px",
                            display: "inline-block",
                            width: "100%",
                        }}
                    >
                        <h5
                            className="mb-1"
                            style={{
                                marginBottom: "10px !important",
                                fontSize: "2.4vh",
                                display: "inline-flex",
                                alignItems: "center",
                                wordBreak: "break-word",
                            }}
                        >
                            {props.title}
                        </h5>
                        {props.subTitleRenderer ? (
                            props.subTitleRenderer()
                        ) : (
                            <h5 style={{ fontSize: "1.4vh" }}>{props.subTitle}</h5>
                        )}
                    </div>
                ) : (
                    <div className="p-1">
                        <Skeleton baseColor={theme.skeletonColor} height="2rem" />
                    </div>
                )}
            </div>
            {props.actions && props.actions.length > 0 && (
                <ViewButtonContainer>
                    {props.actions.map((action) => {
                        return (
                            <ViewButton
                                key={action.label}
                                ToolTipMessage={action.label}
                                icon={action.icon}
                                onClick={action.onClick}
                                IconSize={action.IconSize}
                                Size={action.Size}
                                active={action.active}
                                disabled={action.disabled}
                            />
                        );
                    })}
                </ViewButtonContainer>
            )}
            <hr></hr>
            <div className="ml-3 mb-5">
                {props.sections &&
                    Array.isArray(props.sections) &&
                    props.sections
                        .filter(section =>
                            section &&
                            section.title &&
                            Array.isArray(section.details) &&
                            section.details.some(detail => detail && detail.informacion && detail.titulo)
                        )
                        .map((section) => {
                            // Filtrar detalles válidos
                            const validDetails = section.details.filter((el) => {
                                return el && el.informacion && el.titulo;
                            });

                            return (
                                <InformationSection key={section.title} title={section.title}>
                                    {validDetails.map((detail) => (
                                        <InformationRow
                                            key={detail.titulo}
                                            titulo={detail.titulo || ''}
                                            informacion={detail.informacion}
                                            descripcion={detail.descripcion || false}
                                        />
                                    ))}
                                </InformationSection>
                            );
                        })}
            </div>
        </div>
    );
}
